import { createFileRoute } from "@tanstack/react-router";

import { PractitionerBillingPage } from "@/uiKit/pages/PractitionerBillingPage.tsx";

export const Route = createFileRoute("/_practitioner/practitioner-billing")({
  component: PractitionerBillingPage,
});
